module.exports = __webpack_public_path__ + "9cb7d56bcaeaf002de6a64c402d9292a.png";